import { useLocation } from 'react-router-dom';

export function useRouteType() {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);

  const isHomepage = pathname === '/';
  const isAdminHomepage = /^\/admin\/[^/]+\/admin$/.test(pathname);
  const isAuthPage = segments[0] === 'auth';
  //const isAuthPage = /^\/auth(\/.*)?$/.test(pathname);
  const isContactpage = segments[0] === 'contact';
  const isFeedbackpage = segments[0] === 'feedback';
  const isAdminPage = segments[0] === 'admin' && segments.length >= 2;
  const isTournamentRoute = !isHomepage && !isAuthPage && !isContactpage && !isFeedbackpage;

  const LinkParam = (() => {
    if (isAdminPage) return segments[1];
    if (isTournamentRoute && !isAdminPage) return segments[0];
    return null;
  })();

  //const isTournamentHomePage = segments.length === 1 || (segments.length === 2 && segments[0] === 'admin');
  //const isTournamentSubPage = segments.length > 1;

  const isTournamentHomePage = /^\/[^/]+\/?$/.test(pathname) && !isAuthPage && !isContactpage && !isFeedbackpage && !isAdminPage;
  const isTournamentSubPage = /^\/[^/]+\/[^/]+/.test(pathname) && !isAuthPage && !isContactpage && !isFeedbackpage && !isAdminPage ;  
 

  return {
    isHomepage,
    isAuthPage,
    isAdminPage,
    isTournamentRoute,
    isTournamentHomePage,
    isTournamentSubPage,
    isContactpage,
    isFeedbackpage,
    LinkParam, // ← useful for context logic
    isCurrentPage: (path) => pathname === path,
    isAdminHomepage
  };
}
